import { debounce } from 'lodash-es'
import { info, logError, warn } from '#app/lib/loggers'
import { treq } from '#app/lib/treq'

let missingKeys: string[] = []
let disabled = false

export function i18nMissingKey (key: string) {
  if (disabled) return
  if ((key != null) && !missingKeys.includes(key)) {
    missingKeys.push(key)
    return lazyMissingKey()
  }
}

async function sendMissingKeys () {
  if (missingKeys.length > 0) {
    const keysToSend = missingKeys
    // Keys added after this point will join the next batch
    missingKeys = []
    try {
      await treq('i18n', 'post', 'default', { missingKeys: keysToSend })
      info(keysToSend, 'i18n:missing added')
    } catch (err) {
      if (err.statusCode === 404) {
        warn('i18n missing key service is disabled')
        disabled = true
      } else {
        logError(err, 'i18n:missing keys failed to be added')
      }
    }
  }
}

const lazyMissingKey = debounce(sendMissingKeys, 500)
